import { useSelector } from 'react-redux';
import {
    defaultVoluntaryBAZForceTrialTariffs,
    defaultVoluntaryBAZUpdateTariffs,
    voluntarilyBAZPromoForceTrial,
    voluntarilyBAZPromoForceTrialTariffs,
    voluntarilyBAZPromoTariff,
} from 'reactApp/appHelpers/featuresHelpers/features/voluntarilyBAZ';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { UpgradeSubscriptionSelectors } from 'reactApp/modules/upgradeSubscription/upgradeSubscription.selectors';
import { isYear1Period } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

export type VoluntaryPromoConfig = Record<'month' | 'year', Record<number, string>>;
export type VoluntaryPromoForceTrialConfig = Record<'month' | 'year', string>;

const useVoluntaryButtonText = () => {
    const price = useSelector(UpgradeSubscriptionSelectors.getUpgradePrice);

    return `${formatPrice(price)} ₽`;
};

export const getBazUpdateSubscriptionId = (subscription: BillingDataSubscriptionInfo, tariffsMap: VoluntaryPromoConfig) => {
    const subSpace = subscription?.space?.space;
    const subPeriod = subscription?.productPeriod;
    if (!tariffsMap || !subSpace || !subPeriod) {
        return;
    }

    const resultTariffsMap = tariffsMap;

    if (isYear1Period(subPeriod)) {
        return resultTariffsMap?.year[subSpace];
    }

    return resultTariffsMap?.month[subSpace];
};

const getBazForceTrialSubscriptionId = (subscription: BillingDataSubscriptionInfo, tariffsMap: VoluntaryPromoForceTrialConfig) => {
    const subPeriod = subscription?.productPeriod;

    if (!tariffsMap || !subPeriod) {
        return;
    }

    if (isYear1Period(subPeriod)) {
        return tariffsMap.year;
    }

    return tariffsMap.month;
};

export const useVoluntaryBAZPromo = (): { buttonText: string; pw: string; productId: string } => {
    const subscriptions = useSelector(BillingDataSelectors.sortSubscriptionsBySpace);
    const currentSub = subscriptions[subscriptions.length - 1];
    const buttonPrice = useVoluntaryButtonText();
    const pw = useSelector(UpgradeSubscriptionSelectors.getUpgradePW);

    if (voluntarilyBAZPromoForceTrial) {
        const productId = getBazForceTrialSubscriptionId(currentSub, voluntarilyBAZPromoForceTrialTariffs);
        return { buttonText: 'Попробовать за 1 ₽', pw: '', productId: productId || defaultVoluntaryBAZForceTrialTariffs.year };
    }

    const productId = getBazUpdateSubscriptionId(currentSub, voluntarilyBAZPromoTariff);

    return { buttonText: `Обновить за ${buttonPrice}`, pw: pw || '', productId: productId || defaultVoluntaryBAZUpdateTariffs.year[128] };
};
